// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconGifPath = 'M2 2h8v3.825c-.075-.043-.152-.095-.24-.154l-.005-.003C9.33 5.385 8.75 5 7.7 5c-.52 0-.95.107-1.323.286-.339.163-.603.374-.78.516l-.022.017c-.197.158-.3.236-.417.292A1.002 1.002 0 0 1 4.7 6.2c-.44 0-.733-.158-1.122-.425l-.114-.08C3.158 5.476 2.648 5.112 2 5.02V2Zm0 5.125V10h8V7.936c-.629-.12-1.035-.391-1.355-.604l-.004-.003C8.319 7.114 8.147 7 7.7 7c-.23 0-.364.043-.459.089-.116.056-.22.134-.417.292l-.021.017c-.178.142-.442.353-.78.516-.374.18-.804.286-1.324.286-1.059 0-1.767-.442-2.253-.775a15.946 15.946 0 0 0-.447-.3ZM0 0h12v12H0V0Z';
var ActionIconGif = baseIcon('ActionIconGif', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconGifPath
});
export default ActionIconGif;
//# sourceMappingURL=index.js.map